import React, { FC } from "react";
import { RangeGpm } from "../../../data-types";

export type GpmRangeProps = {
  gpm: RangeGpm;
  getGpmClass: (gpm: number) => string;
  decimalPlaces?: number;
};

export const GpmRanged: FC<GpmRangeProps> = ({
  gpm: { lower, upper },
  getGpmClass,
  decimalPlaces = 0,
}) => {
  return (
    <>
      <span
        style={{ marginRight: "1rem" }}
        data-test-id="gpm-ranged-lower"
        className={getGpmClass(lower)}
      >
        {Number(lower.toFixed(decimalPlaces))}%
      </span>
      -
      <span
        style={{ marginLeft: "1rem" }}
        className={getGpmClass(upper)}
        data-test-id="gpm-ranged-upper"
      >
        {Number(upper.toFixed(decimalPlaces))}%
      </span>
    </>
  );
};
